import React from "react";
import "./erxMain.scss";
import {
  ERXComponentsHeader,
  SECTIONAL_TEMPLATES,
  SELECTION_LIST_TITLES,
} from "../ERXConstants/constants";
import UMPView from "./UMPView";
import VitalsView from "./VitalsView";
import PHCView from "./PHCView";
import DiagnosisView from "./DiagnosisView";
import PREXView from "./PREXView";
import DMView from "./DMView";
import PatientFollowUp from "./PFUView";
import DoctorNotes from "./DNView";
import dragHandle from "../../../assets/dragHandle.svg";
import settingIcon from "../../../assets/settings_gear_icon.svg";
import settingIconActive from "../../../assets/settings_gear_icon_active.svg";
import SectionSetting from "./SectionSetting";
import CollapseIcon from "../../../assets/rx_expand.svg";
import SIView from "./SIView";
import EditableLabel from "../common/EditableLabel";
import CustomSectionView from "./CustomSectionView";
import deleteIcon from "../../../assets/delete_icon_pre.svg";
import addIcon from "../../../assets/addIcon.png";
import ObstetricCalculatorView from "./OCView";
import SectionDetailsDropdown from "../common/SectionDetailsDropdown";
import SaveTemplateButton from "../common/SaveTemplateButton";
import SectionTemplate from "../common/SectionTemplate";

const ERXMain = (props) => {
  const {
    erxComponents,
    phcSuggestionObj,
    drugsSuggestionList,
    instructionSuggestionList,
    sectionalTemplateList,
    dragItem,
    dragOverItem,
    customSection,
    doctorSpecialization,
    allowedObstetricDetailsSpecializations,
    toggleSections,
    onDragEnter,
    onDragStart,
    drop,
    settingIconClick,
    showSettingUi,
    handleSetting,
    draggable,
    setDraggable,
    handleAddCustomSection,
    handleEditLabel,
    handleDeleteCustomSection,
    selectedTemplate,
    updatedGender,
    setSelectedSectionTemp,
    selectedSectionTemp,
    onSectionTempSave,
    onSectionTempDelete,
    getSectionalTemplates,
    setIsTemplateSelected,
  } = props;

  const getSettingsListForHistory = (settingsList) => {
    if (updatedGender?.toLowerCase() !== "female") {
      return settingsList.filter(
        (data) =>
          data?.que_key !== "menstrual_history" &&
          data?.que_key !== "obstetric_history"
      );
    }
    return settingsList;
  };

  // Display UI ===>

  function displayTemplateListSaveBtnUi(comp) {
    return (
      <div className="template-details-save-btn-wrapper">
        <SectionDetailsDropdown
          comp={comp}
          selectedSectionTemp={selectedSectionTemp}
          setSelectedSectionTemp={setSelectedSectionTemp}
          onSectionTempDelete={onSectionTempDelete}
          sectionalTemplateList={sectionalTemplateList}
          getSectionalTemplates={getSectionalTemplates}
          setIsTemplateSelected={setIsTemplateSelected}
        />
        <SaveTemplateButton
          comp={comp}
          selectedSectionTemp={selectedSectionTemp}
          sectionalTemplateList={sectionalTemplateList}
          onSave={onSectionTempSave}
        />
      </div>
    );
  }

  const displayERXMain = () => {
    return (
      <div
        className="erx-main"
        style={{
          paddingBottom: window.innerWidth < 767 ? "0" : "",
          height: selectedTemplate ? "82vh" : "88vh",
        }}
        onDragEnd={drop}
      >
        {erxComponents.map(
          (comp, index) =>
            comp.show &&
            (comp.title === ERXComponentsHeader.OBSTETRIC_CALCULATOR
              ? updatedGender?.toLowerCase() === "female" &&
                allowedObstetricDetailsSpecializations.includes(
                  doctorSpecialization
                )
              : true) && (
              <div
                ref={dragItem}
                className="p-0"
                key={comp.id}
                draggable={comp.draggable && draggable}
                onDragEnter={(e) => {
                  onDragEnter(e, index);
                }}
                onDragStart={(e) => {
                  onDragStart(e, index);
                }}
              >
                {comp.title !== ERXComponentsHeader.GROWTH_CHART &&
                comp.name !== SELECTION_LIST_TITLES.CUSTOM_SECTION1 &&
                comp.name !== SELECTION_LIST_TITLES.CUSTOM_SECTION2 &&
                comp.name !== SELECTION_LIST_TITLES.CUSTOM_SECTION3 ? (
                  <div className="erx-main-section" ref={dragOverItem}>
                    <div
                      className="erx-main-section-header-cont"
                      id={comp.hasInputs ? "" : comp.name}
                    >
                      <div className="erx-main-section-header-wrapper">
                        <div
                          className="erx-main-section-header"
                          onMouseDown={() => setDraggable(false)}
                          onMouseUp={() => setDraggable(true)}
                          onClick={() => toggleSections(comp)}
                        >
                          {showSettingUi && showSettingUi === comp.id
                            ? "Settings"
                            : comp.title}
                        </div>
                        {(comp.title ===
                          ERXComponentsHeader.UPLOAD_MANUAL_PRESCRIPTION ||
                          comp.title === ERXComponentsHeader.FILES) &&
                          window.innerWidth > 767 && (
                            <div className="upload-file-size-limit">
                              Max File size : 20 MB
                            </div>
                          )}

                        {(comp.title === ERXComponentsHeader.DIAGNOSIS ||
                          comp.title ===
                            ERXComponentsHeader.DRUG_OR_MEDICINES ||
                          comp.title ===
                            ERXComponentsHeader.SUGGESTED_INVESTIGATION) &&
                          window.innerWidth > 767 &&
                          displayTemplateListSaveBtnUi(comp)}

                        {/* ids in erxComponents for showing settings */}
                        {comp.showSettings && (
                          <img
                            src={
                              showSettingUi && showSettingUi === comp.id
                                ? settingIconActive
                                : settingIcon
                            }
                            alt=""
                            style={{ height: "19px" }}
                            className="erx-main-section-header-arrow mr-2"
                            onClick={() => {
                              if (showSettingUi === comp.id) {
                                settingIconClick(0);
                              } else {
                                settingIconClick(comp.id);
                              }
                            }}
                            onDragStart={(e) => e.preventDefault()}
                          ></img>
                        )}
                        {/* ids in erxComponents for showing drag handle */}
                        {comp.draggable && (
                          <div style={{ cursor: "pointer" }}>
                            <img
                              src={dragHandle}
                              alt=""
                              className="erx-main-section-header-arrow mr-2"
                              onMouseDown={() => setDraggable(true)}
                              onMouseUp={() => setDraggable(false)}
                            />
                          </div>
                        )}
                        <img
                          src={CollapseIcon}
                          alt=""
                          onClick={() => toggleSections(comp)}
                          className={
                            "erx-main-section-header-arrow " +
                            (comp.expand
                              ? "erx-main-section-header-up-arrow"
                              : "erx-main-section-header-down-arrow")
                          }
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>

                      {(comp.title === ERXComponentsHeader.DIAGNOSIS ||
                        comp.title === ERXComponentsHeader.DRUG_OR_MEDICINES ||
                        comp.title ===
                          ERXComponentsHeader.SUGGESTED_INVESTIGATION) &&
                        window.innerWidth < 767 &&
                        comp.expand &&
                        displayTemplateListSaveBtnUi(comp)}
                    </div>
                    {comp.expand && (
                      <div
                        onMouseDown={() => setDraggable(false)}
                        onMouseUp={() => setDraggable(true)}
                      >
                        {comp.title ===
                          ERXComponentsHeader.UPLOAD_MANUAL_PRESCRIPTION && (
                          <div className="erx-main-section-content">
                            <UMPView {...props} element={comp} />
                          </div>
                        )}
                        {comp.title === ERXComponentsHeader.VITALS && (
                          <div className="erx-main-section-content">
                            {comp.id === showSettingUi ? (
                              <SectionSetting
                                id={comp.id}
                                setting={comp.settings}
                                handleSetting={(ques, ans) =>
                                  handleSetting(ques, ans, index)
                                }
                              />
                            ) : (
                              <VitalsView {...props} element={comp} />
                            )}
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.OBSTETRIC_CALCULATOR && (
                          <div className="erx-main-section-content">
                            {comp.id === showSettingUi ? (
                              <SectionSetting
                                id={comp.id}
                                setting={comp.settings}
                                handleSetting={(ques, ans) => {
                                  handleSetting(ques, ans, index);
                                }}
                              />
                            ) : (
                              <ObstetricCalculatorView
                                {...props}
                                element={comp}
                              />
                            )}
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.PATIENT_HISTORY_AND_COMPLAINTS && (
                          <div className="erx-main-section-content">
                            {comp.id === showSettingUi ? (
                              <SectionSetting
                                id={comp.id}
                                setting={getSettingsListForHistory(
                                  comp?.settings
                                )}
                                handleSetting={(ques, ans) => {
                                  handleSetting(ques, ans, index);
                                }}
                              />
                            ) : (
                              <PHCView
                                {...props}
                                element={comp}
                                phcSuggestionObj={phcSuggestionObj}
                              />
                            )}
                          </div>
                        )}
                        {comp.title === ERXComponentsHeader.DIAGNOSIS && (
                          <div className="erx-main-section-content">
                            {comp.id === showSettingUi ? (
                              <SectionSetting
                                id={comp.id}
                                setting={comp.settings}
                                handleSetting={(ques, ans) =>
                                  handleSetting(ques, ans, index)
                                }
                              />
                            ) : (
                              <div>
                                <SectionTemplate
                                  templatetitle={
                                    selectedSectionTemp[
                                      SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE
                                    ].selected
                                      ? selectedSectionTemp[
                                          SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE
                                        ].template_name
                                      : ""
                                  }
                                />
                                <DiagnosisView {...props} element={comp} />
                              </div>
                            )}
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.PATIENT_OR_REPORTS_EXAMINATION && (
                          <div className="erx-main-section-content">
                            {comp.id === showSettingUi ? (
                              <SectionSetting
                                id={comp.id}
                                setting={comp.settings}
                                handleSetting={(ques, ans) =>
                                  handleSetting(ques, ans, index)
                                }
                              />
                            ) : (
                              <PREXView {...props} element={comp} />
                            )}
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.DRUG_OR_MEDICINES && (
                          <div className="erx-main-section-content">
                            <SectionTemplate
                              templatetitle={
                                selectedSectionTemp[
                                  SECTIONAL_TEMPLATES.DRUG_TEMPLATE
                                ].selected
                                  ? selectedSectionTemp[
                                      SECTIONAL_TEMPLATES.DRUG_TEMPLATE
                                    ].template_name
                                  : ""
                              }
                            />
                            <DMView
                              {...props}
                              element={comp}
                              drugsSuggestionList={drugsSuggestionList}
                            />
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.PATIENT_FOLLOWUP && (
                          <div className="erx-main-section-content">
                            <PatientFollowUp {...props} element={comp} />
                          </div>
                        )}
                        {comp.title ===
                          ERXComponentsHeader.SUGGESTED_INVESTIGATION && (
                          <div className="erx-main-section-content">
                            <SectionTemplate
                              templatetitle={
                                selectedSectionTemp[
                                  SECTIONAL_TEMPLATES
                                    .SUGGESTED_INVESTIGATION_TEMPLATE
                                ].selected
                                  ? selectedSectionTemp[
                                      SECTIONAL_TEMPLATES
                                        .SUGGESTED_INVESTIGATION_TEMPLATE
                                    ].template_name
                                  : ""
                              }
                            />
                            <SIView
                              {...props}
                              element={comp}
                              instructionSuggestionList={
                                instructionSuggestionList
                              }
                            />
                          </div>
                        )}
                        {comp.title === ERXComponentsHeader.DOCTOR_NOTES && (
                          <div className="erx-main-section-content">
                            <DoctorNotes {...props} element={comp} />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : comp.name === SELECTION_LIST_TITLES.CUSTOM_SECTION1 ||
                  comp.name === SELECTION_LIST_TITLES.CUSTOM_SECTION2 ||
                  comp.name === SELECTION_LIST_TITLES.CUSTOM_SECTION3 ? (
                  <div className="erx-main-section" ref={dragOverItem}>
                    <div
                      className="erx-main-section-header-cont"
                      id={comp.hasInputs ? "" : comp.name}
                    >
                      <div className="erx-main-section-header-wrapper">
                        <div
                          className="erx-main-section-header"
                          onMouseDown={() => setDraggable(false)}
                          onMouseUp={() => setDraggable(true)}
                        >
                          {showSettingUi && showSettingUi === comp.id ? (
                            "Settings"
                          ) : (
                            <EditableLabel
                              title={comp.title}
                              handleEditInputChange={(title) =>
                                handleEditLabel(title, comp?.name)
                              }
                              toggleSections={toggleSections}
                              comp={comp}
                            />
                          )}
                        </div>
                        <img
                          src={deleteIcon}
                          alt=""
                          className="erx-main-section-header-delete"
                          onClick={() => handleDeleteCustomSection(comp?.name)}
                        />
                        {comp.draggable && (
                          <div style={{ cursor: "pointer" }}>
                            <img
                              src={dragHandle}
                              alt=""
                              className="erx-main-section-header-arrow mr-2"
                              onMouseDown={() => setDraggable(true)}
                              onMouseUp={() => setDraggable(false)}
                            />
                          </div>
                        )}
                        <img
                          src={CollapseIcon}
                          alt=""
                          onClick={() => toggleSections(comp)}
                          className={
                            "erx-main-section-header-arrow " +
                            (comp.expand
                              ? "erx-main-section-header-up-arrow"
                              : "erx-main-section-header-down-arrow")
                          }
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    {comp.expand && (
                      <div
                        onMouseDown={() => setDraggable(false)}
                        onMouseUp={() => setDraggable(true)}
                      >
                        {comp.name ===
                          SELECTION_LIST_TITLES.CUSTOM_SECTION1 && (
                          <div className="erx-main-section-content vaccine-content">
                            <CustomSectionView
                              {...props}
                              element={comp}
                              selectedCustomSection={
                                customSection.value[
                                  SELECTION_LIST_TITLES.CUSTOM_SECTION1
                                ]
                              }
                              sectionName={
                                SELECTION_LIST_TITLES.CUSTOM_SECTION1
                              }
                            />
                          </div>
                        )}
                        {comp.name ===
                          SELECTION_LIST_TITLES.CUSTOM_SECTION2 && (
                          <div className="erx-main-section-content vaccine-content">
                            <CustomSectionView
                              {...props}
                              element={comp}
                              selectedCustomSection={
                                customSection.value[
                                  SELECTION_LIST_TITLES.CUSTOM_SECTION2
                                ]
                              }
                              sectionName={
                                SELECTION_LIST_TITLES.CUSTOM_SECTION2
                              }
                            />
                          </div>
                        )}
                        {comp.name ===
                          SELECTION_LIST_TITLES.CUSTOM_SECTION3 && (
                          <div className="erx-main-section-content vaccine-content">
                            <CustomSectionView
                              {...props}
                              element={comp}
                              selectedCustomSection={
                                customSection.value[
                                  SELECTION_LIST_TITLES.CUSTOM_SECTION3
                                ]
                              }
                              sectionName={
                                SELECTION_LIST_TITLES.CUSTOM_SECTION3
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            )
        )}

        <div className="erx-main-growth-section">
          <div>
            {Object?.keys(customSection?.value)?.length < 3 && (
              <div
                className="erx-main-add-custom-section-btn"
                onClick={handleAddCustomSection}
              >
                <img
                  src={addIcon}
                  alt=""
                  className="erx-main-add-custom-section-icon"
                />
                <div className="erx-main-growth-text">
                  {"Add Custom Section"}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // <===

  return <>{displayERXMain()}</>;
};

export default ERXMain;
